module.exports = __webpack_public_path__ + "img/Pelletsofen-pelletheizung.3df1bb8.webp";